(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["back-to-top"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    let backToTopButton = document.querySelector('[data-shopify-block-id="{{ block.id }}"] .back-to-top') || document.querySelector('.back-to-top');

    if (!backToTopButton) return;

    // Move button to body to escape any container stacking contexts
    const buttonClone = backToTopButton.cloneNode(true);
    backToTopButton.remove();
    document.body.appendChild(buttonClone);
    backToTopButton = buttonClone;

    // Show/hide button based on scroll position
    const handleScroll = function() {
      if (window.scrollY > 300) {
        backToTopButton.classList.add('visible');
      } else {
        backToTopButton.classList.remove('visible');
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Scroll to top when clicked
    backToTopButton.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    // Initial check
    handleScroll();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-title"] && !Shopify.designMode) return;
  try {
    // Shrinks the title font just enough so its longest word fits the available
  // width, instead of letting long words (e.g. "Sauerstofftherapie") break mid-word.
  // All titles in the same section share the smallest scale, so they stay the same size.
  if (!customElements.get('collection-title-fit')) {
    const MIN_FONT_SIZE = 12;
    const canvas = document.createElement('canvas').getContext('2d');
    const groups = new Map();
    const pending = new Set();

    const scheduleGroup = (root) => {
      if (pending.has(root)) return;
      pending.add(root);
      requestAnimationFrame(() => {
        pending.delete(root);
        fitGroup(root);
      });
    };

    const fitGroup = (root) => {
      const measured = [...(groups.get(root) ?? [])].map((el) => el.measure()).filter(Boolean);
      if (!measured.length) return;

      const scale = Math.min(1, ...measured.map(({ available, widestWord }) => available / widestWord));
      for (const { el, baseSize } of measured) {
        el.text.style.fontSize =
          scale < 1 ? `${Math.max(MIN_FONT_SIZE, Math.floor(baseSize * scale * 10) / 10)}px` : '';
      }
    };

    class CollectionTitleFit extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('.text-block > *');
        this.textBlock = this.querySelector('.text-block');
        // The optional link wrapper sizes to its content, so measure from the element around it.
        this.container = (this.closest('.collection-title-link') ?? this).parentElement;
        while (this.container && ['inline', 'contents'].includes(getComputedStyle(this.container).display)) {
          this.container = this.container.parentElement;
        }
        if (!this.text || !this.container) return;

        this.root = this.closest('.shopify-section') ?? document.body;
        if (!groups.has(this.root)) groups.set(this.root, new Set());
        groups.get(this.root).add(this);

        this.lastWidth = null;
        this.observer = new ResizeObserver(() => {
          const width = this.container.clientWidth;
          if (width === this.lastWidth) return;
          this.lastWidth = width;
          scheduleGroup(this.root);
        });
        this.observer.observe(this.container);
        document.fonts?.ready.then(() => scheduleGroup(this.root));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        const group = groups.get(this.root);
        if (!group) return;
        group.delete(this);
        if (group.size) scheduleGroup(this.root);
        else groups.delete(this.root);
      }

      measure() {
        const containerStyle = getComputedStyle(this.container);
        const blockStyle = getComputedStyle(this.textBlock);
        const available =
          this.container.clientWidth -
          parseFloat(containerStyle.paddingLeft) -
          parseFloat(containerStyle.paddingRight) -
          parseFloat(blockStyle.paddingLeft) -
          parseFloat(blockStyle.paddingRight);
        if (available <= 0) return null;

        this.text.style.fontSize = '';
        const style = getComputedStyle(this.text);
        const letterSpacing = parseFloat(style.letterSpacing) || 0;
        let content = this.text.textContent.trim();
        if (style.textTransform === 'uppercase') content = content.toUpperCase();

        canvas.font = `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        const widestWord = Math.max(
          ...content.split(/\s+/).map((word) => canvas.measureText(word).width + letterSpacing * word.length)
        );

        return { el: this, available, widestWord, baseSize: parseFloat(style.fontSize) };
      }
    }

    customElements.define('collection-title-fit', CollectionTitleFit);
  }
  } catch(e) { console.error(e); }
})();

})();
